// Public, indexable SEO landing page for GCSE Combined Science (Biology, Chemistry, Physics).
import GCSESubjectHub from './GCSESubjectHub';

const config = {
  subjectKey: 'science',
  path: '/gcse-science-revision',
  appHubPath: '/science',
  crumbLabel: 'GCSE Science Revision',
  seoTitle: 'GCSE Science Revision — Biology, Chemistry, Physics',
  seoDescription:
    'Full GCSE Science revision for AQA: Biology B1-B7, Chemistry C1-C10, Physics P1-P7. Required Practicals, AI-marked 6-mark questions, Higher tier. Try free.',
  eyebrow: 'GCSE Science · AQA · Combined + Triple',
  heroChip: 'bg-emerald-100 text-emerald-700 border border-emerald-200',
  h1: 'GCSE Science Revision for Grade 9',
  heroLede:
    'Biology, Chemistry, Physics — every AQA section, every required practical, every 6-mark exam question with AI marking. Higher and Foundation tiers, with a dedicated Required Practicals Hub aggregating all 13 authored RPs.',

  coverageLede:
    'Every section maps directly to the AQA GCSE specification. Topics include diagrams, glossary, AQA-style 6-mark exam questions with mark schemes, and AI-marked feedback that classifies your dropped marks.',
  coverage: [
    { title: 'Biology B1 — Cell Biology',                 body: 'Eukaryotes/prokaryotes, animal & plant cells, microscopy (RP1), stem cells, mitosis, diffusion / osmosis / active transport (RP2).' },
    { title: 'Biology B2-B7',                             body: 'Organisation, infection & response, bioenergetics, homeostasis, inheritance, ecology — 49 topics across 7 sections.' },
    { title: 'Chemistry C1 — Atomic Structure',           body: 'Atoms / elements / compounds, isotopes, electronic configuration, Mendeleev, Group 1 / 7 / 0.' },
    { title: 'Chemistry C2-C10',                          body: 'Bonding, quantitative chemistry, chemical changes, energy, rates, organic, analysis, atmosphere, resources — 40 topics.' },
    { title: 'Physics P1 — Energy',                       body: 'Stores & transfers, KE/GPE/EPE calculations, SHC (RP1), power & efficiency, energy resources.' },
    { title: 'Physics P2-P7',                             body: 'Electricity, particle model, atomic structure, forces, waves, magnetism — 25 topics including Higher-tier flagging.' },
    { title: 'Required Practicals Hub',                   body: 'All 13 authored AQA RPs across Biology, Chemistry and Physics in one filterable hub — direct deep-links into each topic\'s practical tab.' },
    { title: 'Mock Exams',                                body: '12 section mocks + 1 full Combined Science mock — all auto-marked with answer review.' },
  ],

  tipLabels: [
    'Vaccination & immunity',
    'Group 0 noble gases',
    'EM spectrum uses',
  ],

  finalCtaH2: 'Lock in your Grade 9 Science marks',
  finalCtaLede:
    'Open your free 7-day Early Access. Get every Bio, Chem and Physics section, every required practical, AI-marked 6-mark questions and examiner intel.',

  faqs: [
    {
      q: 'Is this Combined Science or Triple Science?',
      a: 'Both. The core 114 GCSE topics cover the AQA Combined Science (Trilogy) specification. Higher-only / Triple-only content (e.g. monoclonal antibodies, transformers, motor effect) is flagged with a Higher-tier badge so Triple students know exactly which extra material to cover.',
    },
    {
      q: 'Do you cover the Required Practicals?',
      a: 'Yes — there is a dedicated Required Practicals Hub at /science/required-practicals aggregating all 13 authored AQA RPs across Biology, Chemistry and Physics. Each RP card deep-links into the matching topic\'s Practical tab with method, safety and tips.',
    },
    {
      q: 'How are 6-mark questions marked?',
      a: 'Every long-answer (Bio Q "Explain how vaccination provides long-term immunity", Chem Q "Explain trends in the periodic table", etc.) is AI-marked against the AQA mark scheme — you get marks_awarded, target grade band, missed mark-scheme points, keyword check, and an examiner-style summary.',
    },
    {
      q: 'Is there a Higher / Foundation toggle?',
      a: 'Yes — every GCSE section page has a tier filter (All / Foundation / Higher) so pupils only see content for their target tier. Higher-only topics are flagged with a clear badge.',
    },
    {
      q: 'Which exam board is supported?',
      a: 'AQA primarily. Most topics are directly transferable to Edexcel and OCR Combined / Triple Science as the underlying GCSE specification overlaps. Mark schemes and exam questions follow the AQA style.',
    },
    {
      q: 'How much does it cost?',
      a: 'Start with a 7-day free trial. Paid plans start at £4.99/month and the number of pupil accounts depends on the parent subscription. See /pricing.',
    },
  ],
};

export default function GCSEScienceRevisionHub() {
  return <GCSESubjectHub config={config} />;
}
